module.exports = __webpack_public_path__ + "c8439ad4c16a03813538e949ba02abb6.svg";